/**
 * Parses a newline-separated list of usernames, trimming whitespace
 * and filtering out empty lines and HTML comments.
 *
 * @param {string} input - Newline-separated string of usernames
 * @returns {string[]} - Array of cleaned usernames
 */
export const parseUsernames = (input) => {
  return input
    .split('\n')
    .map(x => x.trim())
    .filter(x => x && !x.startsWith('<!--'));
};
